import { GridLegacy as Grid, Typography, useTheme } from "@mui/material";
import { Dialog } from "components/Dialog";
import CopyableTypography from "components/Typography/CopyableTypography";
import { useCallback, useState } from "react";
import { prettyPrintDateTime } from "util/dates";

export interface ScreenshotItem {
  src: string;
  createdAt: string;
  errorMessage?: string | null;
}

export interface ScreenshotsTabProps {
  screenshotSrcs: ScreenshotItem[];
}

export function ScreenshotsTab({ screenshotSrcs }: ScreenshotsTabProps) {
  const theme = useTheme();
  const handleImageClick = useCallback((src: string) => window.open(src, "_blank"), []);
  const [dialogMessage, setDialogMessage] = useState<string | null>(null);

  if (screenshotSrcs.length === 0) {
    return <Typography color="text.secondary">No screenshots for this job.</Typography>;
  }

  return (
    <>
      <Grid container spacing={1}>
        {screenshotSrcs.map(({ createdAt, src, errorMessage }) => (
          <Grid item key={src} display="flex" flexDirection="column" alignItems="center">
            <img
              style={{
                width: 200,
                height: 200,
                borderRadius: 4,
                marginTop: theme.spacing(2),
                marginLeft: theme.spacing(1),
                marginRight: theme.spacing(2),
                cursor: "pointer",
              }}
              src={src}
              alt={`Geppetto error screenshot ${src}`}
              onClick={() => handleImageClick(src)}
            />
            <Typography variant="caption" sx={{ marginTop: theme.spacing(1), textAlign: "center" }}>
              {prettyPrintDateTime(createdAt)}
            </Typography>
            {errorMessage && (
              <Typography
                variant="caption"
                color="error"
                onClick={() => setDialogMessage(errorMessage)}
                sx={{
                  maxWidth: 200,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  cursor: "pointer",
                  textAlign: "center",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                {errorMessage}
              </Typography>
            )}
          </Grid>
        ))}
      </Grid>
      <Dialog
        open={dialogMessage !== null}
        onClose={() => setDialogMessage(null)}
        title="Log Message"
        noPrimaryAction
      >
        <CopyableTypography variant="body2" text={dialogMessage} />
      </Dialog>
    </>
  );
}
